import images from '@assets/images/index'

import { $EntityLevel } from '@suntex.fim/enums'
import { useFramework } from '@suntex.fim/framework'
import { useEntityContext } from '@suntex.fim/nav'
import {
  TeamPrintLogins as TeamPrintLoginsView,
  useOptionalTeamInfo
} from '@suntex.fim/team'

import { capitalizeFirstLetter } from '../AssessmentReport/AssessmentReportNavigation'

function TeamPrintLogins() {
  const { api } = useFramework()
  const { entityLevel: apiLevel, entityId: apiId } = useEntityContext()
  const team = useOptionalTeamInfo()

  if (!apiId) {
    return null
  }

  return (
    <TeamPrintLoginsView
      teamName={team?.name ?? ''}
      roleLabel={capitalizeFirstLetter($EntityLevel.describe(apiLevel).slug)}
      qrCodeSheetIllustration={<images.PaperBadge />}
      plainPaperIllustration={<images.PlainPaper />}
      loadMembershipCards={async () => {
        const response = await api.get_Team_MembershipCards({
          entityId: Number(apiId),
          entityLevel: apiLevel
        })
        return response?.membershipCards ?? []
      }}
    />
  )
}

export default TeamPrintLogins
